import { render, staticRenderFns } from "./fundProject.vue?vue&type=template&id=298de251&scoped=true&"
import script from "./fundProject.vue?vue&type=script&lang=ts&"
export * from "./fundProject.vue?vue&type=script&lang=ts&"
import style0 from "./fundProject.vue?vue&type=style&index=0&id=298de251&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298de251",
  null
  
)

export default component.exports